import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import IconBase from './IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AppStore = function AppStore(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 163 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 48 : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 163 48"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "1.09766",
      y: "0.5",
      width: "161",
      height: "47",
      rx: "7.5",
      fill: "#050038"
    }), /*#__PURE__*/_jsx("path", {
      d: "M57.4984 12.292C57.4984 13.2974 57.2007 14.098 56.6044 14.6953C55.9271 15.4054 55.0444 15.7607 53.9593 15.7607C52.9201 15.7607 52.0365 15.4007 51.3099 14.6798C50.582 13.9593 50.2188 13.0659 50.2188 11.9999C50.2188 10.9335 50.582 10.0406 51.3099 9.31962C52.0365 8.59914 52.9201 8.23866 53.9593 8.23866C54.4749 8.23866 54.9686 8.33946 55.4373 8.54058C55.906 8.74218 56.282 9.00978 56.5633 9.34494L55.9304 9.97818C55.4537 9.40866 54.7975 9.12414 53.9593 9.12414C53.2013 9.12414 52.546 9.39042 51.9929 9.92334C51.4397 10.4569 51.1633 11.1487 51.1633 11.9999C51.1633 12.8512 51.4397 13.543 51.9929 14.0765C52.546 14.6095 53.2013 14.8757 53.9593 14.8757C54.7633 14.8757 55.4336 14.608 55.9702 14.0719C56.3186 13.7225 56.5201 13.237 56.5739 12.6135H53.9593V11.7487H57.4483C57.482 11.9367 57.4984 12.1172 57.4984 12.292Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M57.4993 12.292H57.3793C57.3783 13.2745 57.0914 14.0375 56.5204 14.6104L56.5191 14.6114L56.5187 14.6123C55.8629 15.298 55.02 15.6393 53.9601 15.6407C52.9486 15.6393 52.102 15.2943 51.3951 14.5949C50.6898 13.8941 50.3409 13.0387 50.3396 11.9999C50.3409 10.9607 50.6898 10.1057 51.3951 9.40542C52.102 8.70558 52.9486 8.3601 53.9601 8.35866C54.4603 8.35866 54.9366 8.45622 55.3908 8.65074C55.8454 8.8467 56.2046 9.1035 56.4722 9.42234L56.5641 9.34494L56.4793 9.2601L55.8464 9.89382L55.9312 9.97818L56.0237 9.90138C55.5248 9.30366 54.8246 9.00234 53.9601 9.00414C53.1741 9.00318 52.4827 9.28398 51.9108 9.83718C51.3333 10.3922 51.0432 11.1229 51.0441 11.9999C51.0432 12.877 51.3333 13.6077 51.9108 14.1627C52.4827 14.7159 53.1741 14.9967 53.9601 14.9957C54.7908 14.9972 55.4986 14.7154 56.0559 14.1567C56.4282 13.7835 56.6391 13.2665 56.6944 12.6238L56.7056 12.4935H54.0801V11.8687H57.4491V11.7487L57.3309 11.7698C57.3638 11.9517 57.3793 12.1246 57.3793 12.292H57.4993H57.6193C57.6193 12.1096 57.6024 11.9222 57.5672 11.7272L57.5494 11.6287H53.8401V12.6135V12.7335H56.5748V12.6135L56.4553 12.6032C56.4024 13.207 56.2101 13.6617 55.8862 13.987C55.3706 14.5007 54.7378 14.7543 53.9601 14.7557C53.2303 14.7548 52.6111 14.5035 52.0772 13.9903C51.5485 13.4788 51.2854 12.8259 51.2841 11.9999C51.2854 11.174 51.5485 10.5211 52.0772 10.0096C52.6111 9.49638 53.2303 9.2451 53.9601 9.24414C54.7716 9.24606 55.3843 9.51414 55.8394 10.0556L55.9238 10.1559L56.649 9.42978L56.7267 9.35202L56.6559 9.26802C56.3611 8.91654 55.9683 8.63754 55.4854 8.43042C55.0017 8.2227 54.4912 8.11866 53.9601 8.11866C52.8933 8.1177 51.9727 8.4927 51.2259 9.23478C50.4764 9.97542 50.0987 10.9064 50.0996 11.9999C50.0987 13.093 50.4764 14.0245 51.2264 14.7656C51.9727 15.5072 52.8933 15.8817 53.9601 15.8807C55.0711 15.8817 55.9927 15.5127 56.692 14.7782L56.6053 14.6953L56.6901 14.7801C57.3117 14.159 57.6201 13.3199 57.6193 12.292H57.4993Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M63.0314 9.2845H59.7525V11.5674H62.7094V12.4326H59.7525V14.7155H63.0314V15.6H58.8281V8.39998H63.0314V9.2845Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M63.0303 9.28449V9.16449H59.6314V11.6874H62.5883V12.3122L59.6314 12.3126V14.8355H62.9103V15.48H58.947V8.51997H62.9103V9.28449H63.0303V9.16449V9.28449H63.1503V8.39997V8.27997H58.707V15.72H63.1503V14.7155V14.5955H59.8714V12.5526H62.8283V11.5674V11.4474H59.8714V9.40449H63.1503V9.28449H63.0303Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M66.9329 15.6H66.0071V9.2845H63.9961V8.39998H68.9438V9.2845H66.9329V15.6Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M66.9318 15.6V15.48H66.126V9.16449H64.115V8.51997H68.8227V9.16449H66.8118V15.6H66.9318V15.48V15.6H67.0518V9.40449H69.0627V8.39997V8.27997H63.875V9.28449V9.40449H65.886V15.72H66.9318H67.0518V15.6H66.9318Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.5234 15.6V8.39998H73.4483V15.6H72.5234Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.5223 15.6H72.6423V8.51997H73.3272V15.48H72.5223V15.6H72.6423H72.5223V15.72H73.4472H73.5672V8.27997H72.5223H72.4023V15.72H72.5223V15.6Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M77.5519 15.6H76.6261V9.2845H74.6152V8.39998H79.5628V9.2845H77.5519V15.6Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M77.5508 15.6V15.48H76.745V9.16449H74.7341V8.51997H79.4417V9.16449H77.4308V15.6H77.5508V15.48V15.6H77.6708V9.40449H79.6817V8.39997V8.27997H74.4941V9.28449V9.40449H76.505V15.72H77.5508H77.6708V15.6H77.5508Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M84.3316 14.0667C84.8645 14.6062 85.5166 14.8757 86.2877 14.8757C87.0588 14.8757 87.7113 14.6062 88.2434 14.0667C88.7768 13.5272 89.044 12.8375 89.044 11.9999C89.044 11.1623 88.7768 10.4727 88.2434 9.93318C87.7113 9.39366 87.0588 9.12414 86.2877 9.12414C85.5166 9.12414 84.8645 9.39366 84.3316 9.93318C83.7995 10.4727 83.5324 11.1623 83.5324 11.9999C83.5324 12.8375 83.7995 13.5272 84.3316 14.0667ZM88.9277 14.6695C88.2198 15.3974 87.3395 15.7607 86.2877 15.7607C85.2348 15.7607 84.355 15.3974 83.6487 14.6695C82.9403 13.9424 82.5879 13.0523 82.5879 11.9999C82.5879 10.9475 82.9403 10.0574 83.6487 9.33042C84.355 8.60238 85.2348 8.23866 86.2877 8.23866C87.334 8.23866 88.2119 8.6043 88.923 9.3351C89.6332 10.0659 89.9885 10.9541 89.9885 11.9999C89.9885 13.0523 89.634 13.9424 88.9277 14.6695Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M84.3325 14.0667L84.2471 14.1511C84.7999 14.7122 85.4894 14.9972 86.2886 14.9957C87.0873 14.9972 87.7778 14.7122 88.3295 14.1511C88.8859 13.5895 89.1657 12.8629 89.1649 11.9999C89.1657 11.137 88.8859 10.4104 88.3295 9.84882C87.7778 9.2877 87.0873 9.0027 86.2886 9.00414C85.4894 9.0027 84.7999 9.2877 84.2471 9.84882C83.6921 10.4104 83.4118 11.137 83.4133 11.9999C83.4118 12.8629 83.6921 13.5895 84.2471 14.1511L84.3325 14.0667L84.4178 13.9823C83.9088 13.4643 83.6542 12.8127 83.6533 11.9999C83.6542 11.1872 83.9088 10.5356 84.4178 10.0175C84.9315 9.49962 85.5451 9.24558 86.2886 9.24414C87.0315 9.24558 87.6465 9.49962 88.1589 10.0175C88.6689 10.5356 88.9234 11.1872 88.9244 11.9999C88.9234 12.8127 88.6689 13.4643 88.1589 13.9823C87.6465 14.5003 87.0315 14.7543 86.2886 14.7557C85.5451 14.7543 84.9315 14.5003 84.4178 13.9823L84.3325 14.0667ZM88.9286 14.6695L88.8428 14.5861C88.1547 15.2911 87.3133 15.6393 86.2886 15.6407C85.2634 15.6393 84.422 15.2911 83.7352 14.5861L83.732 14.5823L83.7352 14.5861C83.0486 13.8787 82.7097 13.0256 82.7088 11.9999C82.7097 10.9743 83.0486 10.1212 83.7352 9.41382C84.422 8.70882 85.2634 8.3601 86.2886 8.35866C87.3067 8.3601 88.1462 8.71026 88.8381 9.41898C89.5272 10.1296 89.868 10.9814 89.8694 11.9999C89.868 13.0256 89.5281 13.8787 88.8428 14.5861L88.9286 14.6695L89.0149 14.7529C89.7423 14.0057 90.1102 13.079 90.1094 11.9999C90.1102 10.927 89.7409 10.0022 89.0101 9.25169C88.2789 8.49833 87.3629 8.11734 86.2886 8.11866C85.2086 8.11734 84.2899 8.49653 83.5633 9.24701V9.24653C82.8344 9.99413 82.4678 10.9209 82.4688 11.9999C82.4678 13.079 82.8344 14.0057 83.5633 14.7533L83.5665 14.7567L83.5633 14.7529C84.2899 15.5033 85.2086 15.8817 86.2886 15.8807C87.3681 15.8817 88.2868 15.5033 89.0149 14.7529L88.9286 14.6695Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M91.2871 15.6V8.39998H92.4131L95.9123 14.0011H95.9521L95.9123 12.6135V8.39998H96.8381V15.6H95.8724L92.2115 9.72742H92.1716L92.2115 11.1155V15.6H91.2871Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M91.288 15.6H91.408V8.51997H92.3473L95.8465 14.1211H95.953H96.0762L96.0331 12.6117V8.51997H96.7189V15.48H95.9399L92.2789 9.60741H92.1725H92.0492L92.0923 11.1174V15.48H91.288V15.6H91.408H91.288V15.72H92.2123H92.3323V11.1135L92.2925 9.72417L92.1725 9.72741V9.84741H92.2123V9.72741L92.1106 9.79125L95.8067 15.72H96.8389H96.9589V8.27997H95.9131H95.7931V12.615L95.833 14.0043L95.953 14.0011V13.8811H95.9131V14.0011L96.0149 13.9374L92.4804 8.27997H91.288H91.168V15.72H91.288V15.6Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M128.921 35.9999H131.16V20.9985H128.921V35.9999ZM149.089 26.4023L146.522 32.9062H146.446L143.781 26.4023H141.369L145.364 35.4927L143.087 40.5491H145.423L151.579 26.4023H149.089ZM136.391 34.296C135.656 34.296 134.634 33.9294 134.634 33.022C134.634 31.8641 135.908 31.4202 137.007 31.4202C137.993 31.4202 138.455 31.6325 139.054 31.9223C138.88 33.3117 137.683 34.296 136.391 34.296ZM136.661 26.0741C135.04 26.0741 133.361 26.7885 132.666 28.371L134.653 29.2007C135.078 28.371 135.869 28.1006 136.699 28.1006C137.857 28.1006 139.034 28.7957 139.054 30.0309V30.1851C138.648 29.9535 137.78 29.6062 136.718 29.6062C134.576 29.6062 132.395 30.7832 132.395 32.9835C132.395 34.9907 134.151 36.284 136.119 36.284C137.626 36.284 138.455 35.6085 138.977 34.8173H139.054V35.9751H141.215V30.2235C141.215 27.5606 139.228 26.0741 136.661 26.0741ZM122.822 28.2285H119.638V23.0864H122.822C124.496 23.0864 125.447 24.4724 125.447 25.6574C125.447 26.8199 124.496 28.2285 122.822 28.2285ZM122.765 20.9985H117.399V35.9999H119.638V30.3164H122.765C125.246 30.3164 127.686 28.5196 127.686 25.6574C127.686 22.7952 125.246 20.9985 122.765 20.9985ZM93.5075 34.2988C91.9606 34.2988 90.6654 33.0036 90.6654 31.2248C90.6654 29.4272 91.9606 28.1123 93.5075 28.1123C95.0347 28.1123 96.2333 29.4272 96.2333 31.2248C96.2333 33.0036 95.0347 34.2988 93.5075 34.2988ZM96.0786 27.2423H96.0012C95.4988 26.6432 94.5317 26.1018 93.3139 26.1018C90.762 26.1018 88.423 28.3443 88.423 31.2248C88.423 34.086 90.762 36.3093 93.3139 36.3093C94.5317 36.3093 95.4988 35.7678 96.0012 35.1496H96.0786V35.8841C96.0786 37.837 95.0347 38.8809 93.3528 38.8809C91.9803 38.8809 91.1296 37.8946 90.7812 37.0635L88.8289 37.8754C89.3896 39.2286 90.8783 40.8914 93.3528 40.8914C95.982 40.8914 98.2053 39.3444 98.2053 35.5748V26.4112H96.0786V27.2423ZM99.7517 35.9999H101.994V20.998H99.7517V35.9999ZM105.3 31.0509C105.242 29.0788 106.828 28.0738 107.968 28.0738C108.858 28.0738 109.611 28.5182 109.862 29.1567L105.3 31.0509ZM112.26 29.3498C111.835 28.2088 110.539 26.1018 107.891 26.1018C105.261 26.1018 103.077 28.1704 103.077 31.2056C103.077 34.0668 105.242 36.3093 108.142 36.3093C110.481 36.3093 111.835 34.8786 112.396 34.0475L110.656 32.8874C110.076 33.7382 109.283 34.2988 108.142 34.2988C107.001 34.2988 106.19 33.7767 105.667 32.7524L112.491 29.9296L112.26 29.3498ZM57.8901 27.6678V29.833H63.0711C62.9164 31.0509 62.5104 31.9401 61.8917 32.5588C61.138 33.313 59.9586 34.1441 57.8901 34.1441C54.7001 34.1441 52.2064 31.573 52.2064 28.3832C52.2064 25.1933 54.7001 22.6218 57.8901 22.6218C59.6107 22.6218 60.867 23.2986 61.7951 24.1686L63.3223 22.6415C62.0272 21.404 60.3064 20.4567 57.8901 20.4567C53.5207 20.4567 49.8477 24.014 49.8477 28.3832C49.8477 32.7524 53.5207 36.3093 57.8901 36.3093C60.2488 36.3093 62.0272 35.5364 63.4189 34.086C64.8496 32.6554 65.2944 30.6449 65.2944 29.0212C65.2944 28.5182 65.2559 28.0546 65.1781 27.6678H57.8901ZM71.1847 34.2988C69.6378 34.2988 68.3038 33.0228 68.3038 31.2056C68.3038 29.369 69.6378 28.1123 71.1847 28.1123C72.7311 28.1123 74.0651 29.369 74.0651 31.2056C74.0651 33.0228 72.7311 34.2988 71.1847 34.2988ZM71.1847 26.1018C68.3619 26.1018 66.0612 28.2477 66.0612 31.2056C66.0612 34.1441 68.3619 36.3093 71.1847 36.3093C74.007 36.3093 76.3077 34.1441 76.3077 31.2056C76.3077 28.2477 74.007 26.1018 71.1847 26.1018ZM82.3606 34.2988C80.8143 34.2988 79.4801 33.0228 79.4801 31.2056C79.4801 29.369 80.8143 28.1123 82.3606 28.1123C83.907 28.1123 85.2411 29.369 85.2411 31.2056C85.2411 33.0228 83.907 34.2988 82.3606 34.2988ZM82.3606 26.1018C79.5378 26.1018 77.2377 28.2477 77.2377 31.2056C77.2377 34.1441 79.5378 36.3093 82.3606 36.3093C85.183 36.3093 87.4836 34.1441 87.4836 31.2056C87.4836 28.2477 85.183 26.1018 82.3606 26.1018Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.209 38.8674L13.1198 38.7821C12.7706 38.4126 12.5645 37.8389 12.5645 37.096V37.2708V10.7316C12.5645 10.7292 12.5645 10.7274 12.5645 10.7255C12.5645 10.7278 12.5645 10.7297 12.5645 10.7321V10.9074C12.5645 10.103 12.8048 9.49695 13.2075 9.13359L28.0753 24.001L13.209 38.8674ZM12.5645 10.7241C12.5645 10.658 12.5663 10.5938 12.5696 10.5305C12.5663 10.5933 12.5645 10.658 12.5645 10.7241ZM12.5696 10.5276C12.5696 10.5268 12.5696 10.5258 12.57 10.5249C12.5696 10.5258 12.5696 10.5268 12.5696 10.5276ZM12.57 10.5192C12.57 10.5188 12.57 10.5183 12.57 10.5178C12.57 10.5183 12.57 10.5188 12.57 10.5192Z",
      fill: "url(#paint0_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.0313 29.1343L33.1444 29.0701L39.0159 25.734C39.5757 25.4157 39.9487 25.0299 40.1349 24.6217C39.9492 25.0299 39.576 25.4162 39.0159 25.7344L33.1444 29.0706L33.0313 29.1343ZM33.0328 28.9585L28.0762 24.001L33.0323 19.0444L39.0159 22.4438C39.7757 22.8756 40.2023 23.432 40.2736 24.0006C40.2736 24.001 40.2736 24.002 40.2736 24.0028C40.2023 24.5701 39.7757 25.127 39.0159 25.5586L33.0328 28.9585Z",
      fill: "url(#paint1_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.2684 39.4335C13.8531 39.4335 13.4907 39.2985 13.2081 39.0435L13.2086 39.043C13.4912 39.298 13.854 39.4335 14.2694 39.4335C14.3054 39.4335 14.342 39.4325 14.379 39.4307C14.3415 39.4325 14.3044 39.4335 14.2684 39.4335ZM14.2689 39.2577C13.8536 39.2582 13.4912 39.1227 13.2086 38.8677V38.8673L28.0749 24.0009L33.0315 28.9583L15.6132 38.8551C15.1313 39.1283 14.6747 39.2577 14.2689 39.2577ZM13.2044 39.0402C13.1781 39.0164 13.1523 38.991 13.127 38.9648L13.2044 39.0402Z",
      fill: "url(#paint2_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.0748 24.001L13.207 9.13358C13.4896 8.87906 13.8516 8.74406 14.2664 8.74406C14.6733 8.74406 15.1303 8.8739 15.6132 9.14762L33.0309 19.0444L28.0748 24.001ZM33.143 18.9324L15.6132 8.97242C15.1303 8.69858 14.6733 8.56874 14.2664 8.56874C14.2645 8.56874 14.2632 8.56874 14.2612 8.56874C14.2636 8.56874 14.2654 8.56874 14.2683 8.56874C14.6743 8.56874 15.1308 8.6981 15.6132 8.97194L33.143 18.9324Z",
      fill: "url(#paint3_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.3788 39.4308C14.7561 39.4092 15.1738 39.2793 15.613 39.0305L33.0298 29.1342L15.613 39.0305C15.1741 39.2798 14.7561 39.4092 14.3788 39.4308ZM13.2078 39.0435L13.2041 39.0403C13.2054 39.0413 13.2069 39.0426 13.2078 39.0435ZM13.1267 38.9648L13.1191 38.9574V38.9569C13.122 38.9597 13.1243 38.9624 13.1267 38.9648Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.0312 29.1343L33.1443 29.0701L33.0312 29.1343Z",
      fill: "url(#paint4_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.2691 39.4335C13.8538 39.4335 13.4909 39.298 13.2083 39.043L13.2078 39.0435C13.2069 39.0425 13.2054 39.0412 13.2041 39.0402L13.1267 38.9648C13.1243 38.9624 13.122 38.9596 13.1191 38.9568L13.2083 38.8677C13.4909 39.1227 13.8533 39.2582 14.2686 39.2577C14.6745 39.2577 15.1311 39.1283 15.613 38.8551L33.0312 28.9583L33.1428 29.0699L33.0298 29.1341L15.613 39.0304C15.1738 39.2793 14.7561 39.4091 14.3788 39.4307C14.3417 39.4325 14.3051 39.4335 14.2691 39.4335Z",
      fill: "url(#paint5_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.1198 38.9573C12.7706 38.5878 12.5645 38.0141 12.5645 37.2712V37.2707C12.5645 38.0141 12.7706 38.5873 13.1198 38.9568V38.9573Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.1198 38.9569C12.7706 38.5874 12.5645 38.0142 12.5645 37.2708V37.0959C12.5645 37.8389 12.7706 38.4126 13.1198 38.7821L13.209 38.8674L13.1198 38.9569Z",
      fill: "url(#paint6_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.1191 38.9569L13.2083 38.8674V38.8677L13.1191 38.9569Z",
      fill: "url(#paint7_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.1348 24.6215C40.227 24.4189 40.2735 24.2108 40.2735 24.0026C40.2735 24.0023 40.2735 24.0018 40.2735 24.0018C40.2735 24.2103 40.227 24.4184 40.1348 24.6215Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.1428 29.0698L33.0312 28.9582L39.0143 25.5584C39.7742 25.1267 40.2008 24.5698 40.272 24.0026C40.272 24.2108 40.2256 24.4189 40.1333 24.6214C39.9472 25.0297 39.5741 25.4155 39.0143 25.7337L33.1428 29.0698Z",
      fill: "url(#paint8_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.2723 24.001V24.0005C40.2718 23.3728 39.8523 22.7452 39.0145 22.2689L33.1431 18.9328H33.1426L33.1431 18.9324L39.0145 22.2684C39.8532 22.7447 40.2732 23.3733 40.2723 24.001Z",
      fill: "#404040"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.2725 24.0005C40.2012 23.4319 39.7747 22.8755 39.0148 22.4437L33.0312 19.0444L33.1428 18.9328H33.1433L39.0148 22.2689C39.8525 22.7452 40.272 23.3728 40.2725 24.0005Z",
      fill: "url(#paint9_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5645 10.7256C12.5645 10.7251 12.5645 10.7246 12.5645 10.7241C12.5645 10.7246 12.5645 10.7251 12.5645 10.7256ZM12.5696 10.5306C12.5696 10.5296 12.5696 10.5287 12.5696 10.5277C12.5696 10.5287 12.5696 10.5296 12.5696 10.5306ZM12.57 10.5249C12.57 10.523 12.57 10.5212 12.57 10.5193C12.57 10.5212 12.57 10.523 12.57 10.5249ZM12.57 10.5179C12.6395 9.28511 13.3098 8.57303 14.258 8.56883C13.8469 8.57123 13.4888 8.70623 13.2085 8.95883V8.95835L13.2051 8.96171C13.1756 8.98835 13.1475 9.01655 13.1198 9.04559C12.8048 9.37883 12.6061 9.87803 12.57 10.5179Z",
      fill: "#404040"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5645 10.9072V10.7319C12.5645 10.7295 12.5645 10.7276 12.5645 10.7253C12.5645 10.7248 12.5645 10.7243 12.5645 10.7239C12.5645 10.6577 12.5663 10.5931 12.5696 10.5303C12.5696 10.5293 12.5696 10.5284 12.5696 10.5274C12.5696 10.5266 12.5696 10.5256 12.57 10.5247C12.57 10.5227 12.57 10.5209 12.57 10.519C12.57 10.5185 12.57 10.5181 12.57 10.5176C12.6061 9.87775 12.8048 9.37855 13.1198 9.04531L13.2075 9.13339C12.8048 9.49675 12.5645 10.1027 12.5645 10.9072ZM13.2051 8.96143L13.2085 8.95807C13.2075 8.95951 13.2061 8.96047 13.2051 8.96143Z",
      fill: "url(#paint10_linear)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.0307 19.0444L15.613 9.14767C15.1301 8.87395 14.6731 8.74411 14.2662 8.74411C13.8514 8.74411 13.4895 8.87911 13.2069 9.13363L13.1191 9.04555C13.1469 9.01651 13.1749 8.98831 13.2045 8.96167C13.2054 8.96071 13.2069 8.95975 13.2078 8.95879C13.4881 8.70619 13.8462 8.57119 14.2573 8.56879C14.2583 8.56879 14.2596 8.56879 14.2611 8.56879C14.263 8.56879 14.2643 8.56879 14.2662 8.56879C14.6731 8.56879 15.1301 8.69863 15.613 8.97247L33.1428 18.9325L33.1423 18.9328L33.0307 19.0444Z",
      fill: "url(#paint11_linear)"
    }), /*#__PURE__*/_jsx("rect", {
      x: "1.09766",
      y: "0.5",
      width: "161",
      height: "47",
      rx: "7.5",
      stroke: "#A6A6A6"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear",
        x1: "26.757",
        y1: "10.4517",
        x2: "6.61797",
        y2: "30.5907",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#00A0FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.00657445",
          stopColor: "#00A1FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.2601",
          stopColor: "#00BEFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5122",
          stopColor: "#00D2FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7604",
          stopColor: "#00DFFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#00E3FF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear",
        x1: "41.1994",
        y1: "24.0018",
        x2: "12.163",
        y2: "24.0018",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFE000"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4087",
          stopColor: "#FFBD00"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7754",
          stopColor: "#FFA500"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FF9C00"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear",
        x1: "30.3892",
        y1: "26.7552",
        x2: "3.07923",
        y2: "54.0652",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF3A44"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#C31162"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear",
        x1: "9.35347",
        y1: "0.211459",
        x2: "21.5485",
        y2: "12.4065",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#32A071"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.0685",
          stopColor: "#2DA771"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4762",
          stopColor: "#15CF74"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.8009",
          stopColor: "#06E775"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#00F076"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear",
        x1: "41.1992",
        y1: "24.0017",
        x2: "12.1632",
        y2: "24.0017",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CCB300"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4087",
          stopColor: "#CC9700"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7754",
          stopColor: "#CC8400"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#CC7D00"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear",
        x1: "30.3889",
        y1: "26.7552",
        x2: "3.07898",
        y2: "54.0652",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#CC2E36"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#9C0E4E"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint6_linear",
        x1: "26.757",
        y1: "10.4516",
        x2: "6.61796",
        y2: "30.5906",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#008DE0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.00657445",
          stopColor: "#008DE0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.2601",
          stopColor: "#00A7E0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5122",
          stopColor: "#00B8E0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7604",
          stopColor: "#00C4E0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#00C7E0"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint7_linear",
        x1: "30.3892",
        y1: "26.7553",
        x2: "3.07917",
        y2: "54.0657",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#E0333C"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#AB0F56"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint8_linear",
        x1: "41.1978",
        y1: "24.0015",
        x2: "12.1615",
        y2: "24.0015",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#E0C500"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4087",
          stopColor: "#E0A600"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7754",
          stopColor: "#E09100"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#E08900"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint9_linear",
        x1: "41.1983",
        y1: "24.0017",
        x2: "12.1619",
        y2: "24.0017",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FFE840"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4087",
          stopColor: "#FFCE40"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7754",
          stopColor: "#FFBC40"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FFB540"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint10_linear",
        x1: "26.7569",
        y1: "10.4515",
        x2: "6.61797",
        y2: "30.5904",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#40B8FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.00657445",
          stopColor: "#40B9FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.2601",
          stopColor: "#40CEFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5122",
          stopColor: "#40DDFF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.7604",
          stopColor: "#40E7FF"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#40EAFF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint11_linear",
        x1: "9.3533",
        y1: "0.211513",
        x2: "21.5483",
        y2: "12.4065",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#65B895"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.0685",
          stopColor: "#62BD95"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.4762",
          stopColor: "#50DB97"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.8009",
          stopColor: "#44ED98"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#40F498"
        })]
      })]
    })]
  }));
};

export default AppStore;